/* global treeCost, prices, isPrintPhotoPage  */
const displayTreeNumberElement = document.querySelector('.js-trees-counter');
let donation;

const updateTreesCounter = (donation) => {
  const treesAmount = (donation / treeCost).toPrecision(3);
  const treesPlanted = Math.ceil(treesAmount);
  displayTreeNumberElement.textContent = treesPlanted;
};

const setTotalDonation = function () {
  // TODO: this can be done better
  if (!isPrintPhotoPage) {
    donation = prices[0].costs.without_frame.total_donation;
    updateTreesCounter();
  }
};

export {
  setTotalDonation,
  updateTreesCounter,
};